import React from 'react';
import { useMutation, useQuery } from 'react-query';
import userServices from 'services/httpService/userAuth/userServices';
import { toast } from 'react-toastify';
import ErrorService from 'services/formatError/ErrorService';

import Container from '@mui/material/Container';
import PostCard from 'components/Cards/PostCard';
import Grid from '@mui/material/Grid';
import PageCard from 'components/Cards/PageCard';
import MyThema from 'components/Cards/MyThema';
import AddExperienceCard from 'components/Cards/AddExperienceCard';

function Home() {
  const [allPost, setallPost] = React.useState([]);

  const getAllPosts = useQuery(
    'allpostdata',
    () => userServices.commonGetService(`/post/getAllPost`),
    {
      refetchOnWindowFocus: false,
      onError: (error) => {
        toast.error(ErrorService.uniformError(error));
      },
      onSuccess: (res) => {
        setallPost(res.data.data);
      },
    }
  );

  console.log(allPost);

  return (
    <div>
      <Container maxWidth='xl'>
        <Grid container spacing={2}>
          <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
            <div className=' my-10'>
              <AddExperienceCard />
              <Grid container spacing={2}>
                <PostCard data={allPost} />
              </Grid>
            </div>
          </Grid>

          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <div className='flex my-10'>
              <PageCard />
            </div>
          </Grid>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <MyThema />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

export default Home;
